import React from "react"
import { Loader } from "@/UI"
import { Modal } from "antd"
import { useTranslation } from "react-i18next"

interface ConfirmingSubscriptionModalProps {
  open: boolean
}

const ConfirmingSubscriptionModal: React.FC<ConfirmingSubscriptionModalProps> = ({ open }) => {
  const { t } = useTranslation()

  return (
    <Modal open={open} closable={false} centered footer={false}>
      <div
        id="processing-payment-modal"
        className="flex flex-col items-center justify-center h-full"
        style={{ minHeight: "120px" }}
      >
        <div className="sm:mx-auto sm:w-full sm:max-w-md flex flex-col text-center space-y-1.5">
          <Loader fontSize={24} />
          <p className="font-bold text-xl p-2">
            {t("profile.ConfirmingSubscription.thankYouForChoosingKosmo")}
          </p>
          <p className="text-gray-500">
            {t("profile.ConfirmingSubscriptionModal.confirmingSubscription")}
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmingSubscriptionModal
